export enum FormType {
  PHONE = "phone",
  WHATSAPP = "whatsapp",
  START_PAGE_WHATSAPP = "start_page_whatsapp",
  DOCTOR_WHATSAPP = "doctor_whatsapp",
  FAST_FORM = "fast_form"
}